module.exports = __webpack_public_path__ + "img/cart_btn_black.3514ba6e.svg";